/* Slideshow: selectable transitions (glitch/fade/slide/wipe), autoplay, arrows, dots. */
(function () {
  'use strict';

  function initSlideshow(root) {
    if (root.dataset.slideshowInit) return;
    root.dataset.slideshowInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slide-dot]'));
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var timer = null;
    var interval = parseInt(root.getAttribute('data-autoplay'), 10) || 0;

    function goTo(index) {
      var next = (index + slides.length) % slides.length;
      if (next === current) return;

      slides.forEach(function (slide, i) {
        slide.classList.remove('is-leaving');
        if (i !== next) slide.classList.remove('is-active');
      });

      var leaving = slides[current];
      leaving.classList.add('is-leaving');
      leaving.addEventListener('animationend', function onEnd() {
        leaving.classList.remove('is-leaving');
        leaving.removeEventListener('animationend', onEnd);
      });

      slides[next].classList.add('is-active');
      current = next;

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === next);
      });
    }

    function start() {
      if (!interval) return;
      stop();
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-slide-next]')) {
        goTo(current + 1);
        start();
      } else if (event.target.closest('[data-slide-prev]')) {
        goTo(current - 1);
        start();
      } else {
        var dot = event.target.closest('[data-slide-dot]');
        if (dot) {
          goTo(parseInt(dot.getAttribute('data-slide-dot'), 10));
          start();
        }
      }
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (event) {
      /* Only resume when focus actually leaves the slideshow, not between its controls */
      if (!root.contains(event.relatedTarget)) start();
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      interval = 0;
    }

    /* Autoplay only runs while the slideshow is actually on screen —
       no timers cycling big-image animations the visitor can't see. */
    if (interval && 'IntersectionObserver' in window) {
      var onScreen = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.15 });
      onScreen.observe(root);
    } else {
      start();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
